












export default {
  name: 'InboxIcon',
  props: {
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }
}
